import { Notif } from "../../components/notification";
import { user_routes as routes } from "../../constants/routes";
import { FormUtils } from "../../utils/_FormUtils";
import API from "../../utils/_HttpUtils";


const err_msg = sessionStorage.getItem("PEPERROR");


const form_nationalCode = localStorage.getItem("REG_NC");

$(() => {
    $("#national_code").val(form_nationalCode);
    localStorage.removeItem("REG_NC")
    if (err_msg) {
        new Notif(err_msg, "error", {
            timeout: 5000,
        }).show();
        sessionStorage.removeItem("PEPERROR");
    }

    $("#msisdn").trigger("focus");

    $("form").on("submit", (event) => {
        event.preventDefault();
        const form = $(event.target);
        form.addClass("loading");
        if (FormUtils.validateForm(event.target)) {
            const national_code = form.find("input#national_code").val();
            const msisdn = form.find("input#msisdn").val();
            const illegal_age = form.find("input#under_age_check").is(":checked");
            new API().send('POST', '/register',
                {
                    msisdn,
                    national_code,
                    illegal_age: illegal_age ? 1 : 0,
                    type: 'otpRegister' 
                },
                FormUtils.captchaHeader()
            ).then(({ data }) => {
                sessionStorage.setItem("MCP", data.msisdn); // masked cellphone
                sessionStorage.setItem("MSISDN", msisdn);
                sessionStorage.setItem("NC", national_code);

                window.location.href = routes.auth.get_otp;
            }).catch(() => {
                if (captcha_google) {
                    FormUtils.renewGoogleCaptcha();
                }
                form.removeClass("loading").removeClass("was-validated");
            }).finally(() => {
                form.removeClass("loading");
            });

        } else {
            setTimeout(() => {
                form.removeClass("loading");
            }, 300);
        }
    });
});
